import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["hideLabel", "label", "spinnerClassName", "variant"];

var _templateObject;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { LOADER_VARIANTS } from "../constants";
import { StyledLoaderSpinner, LoaderLabel } from "../elements";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledLoaderWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  cursor: progress;\n  display: inline-flex;\n  flex: 1 1 auto;\n  justify-content: center;\n  stroke: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.color.additional.black.value;
});
export var Loader = function Loader(_ref2) {
  var hideLabel = _ref2.hideLabel,
      label = _ref2.label,
      spinnerClassName = _ref2.spinnerClassName,
      variant = _ref2.variant,
      other = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/_jsxs(StyledLoaderWrapper, _objectSpread(_objectSpread({
    role: "status"
  }, other), {}, {
    children: [/*#__PURE__*/_jsx(StyledLoaderSpinner, {
      className: spinnerClassName
    }), label && /*#__PURE__*/_jsx(LoaderLabel, {
      hideLabel: hideLabel,
      label: label,
      children: label
    })]
  }));
};
Loader.displayName = "Loader";
Loader.propTypes = {
  /** Visually hides loader text */
  hideLabel: PropTypes.bool,

  /** Adds message on the right of the spinner */
  label: PropTypes.node.isRequired,

  /** Adds additional class to spinner */
  spinnerClassName: PropTypes.string,

  /** Loader variations. Values: ['inline'] */
  variant: PropTypes.oneOf(Object.values(LOADER_VARIANTS))
};
Loader.defaultProps = {
  hideLabel: false,
  spinnerClassName: '',
  variant: LOADER_VARIANTS.INLINE
};